
import { useParams, useNavigate } from "react-router-dom";
import { TokenValidator } from "@/components/survey/TokenValidator";
import { SurveyForm } from "@/components/survey/SurveyForm";
import { SurveyLoading } from "@/components/survey/SurveyLoading";
import { useSurvey } from "@/hooks/useSurvey";
import { Progress } from "@/components/ui/progress";

// RTL languages
const RTL_LANGUAGES = ["ar", "fa", "prs"];

const Survey = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  
  // Redirect if no token is provided
  if (!token) {
    navigate("/");
    return null;
  }
  
  const {
    survey,
    participantGroup,
    previousConsent,
    previousAnswers,
    language,
    isLoading,
    currentStep,
    totalSteps,
    handleValidToken,
    handleInvalidToken,
    handleSubmit
  } = useSurvey({ token });
  
  const isRtl = RTL_LANGUAGES.includes(language);

  // Calculate progress percentage
  const progress = Math.round((currentStep / totalSteps) * 100);

  if (isLoading) {
    return <SurveyLoading isRtl={isRtl} />;
  }

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center p-4 bg-background w-full" 
      dir={isRtl ? "rtl" : "ltr"}
    >
      {!survey ? (
        <TokenValidator
          token={token}
          currentLanguage={language}
          onValidToken={handleValidToken}
          onInvalidToken={handleInvalidToken}
        />
      ) : (
        <>
          <div className="w-full max-w-2xl mb-2">
            <Progress value={progress} className="h-1" />
          </div>
          <SurveyForm 
            key={`${survey.id}-${currentStep}`}
            survey={survey} 
            onSubmit={handleSubmit} 
            participantGroup={participantGroup}
            previousConsent={previousConsent}
            previousAnswers={previousAnswers}
            currentStep={currentStep}
            initialLanguage={language}
          />
        </>
      )}
    </div>
  );
};

export default Survey;
